// src/store/authActions.js
import { resetAll } from "../actions/resetActions";
import { persistor } from "../store"; 

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const SET_USER = "SET_USER";
const apiUrl = process.env.REACT_APP_API_URL;

export const login = (email, password) => async (dispatch) => {
  try {
    const response = await fetch(`${apiUrl}/api/auth/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password })
    });

    if (!response.ok) {
      const data = await response.json();
      throw new Error(data.error || "Erreur lors de la connexion");
    }

    const data = await response.json();


    dispatch({
      type: LOGIN_SUCCESS,
      payload: { token: data.token }
    });

    // Charger le profil automatiquement
    dispatch(loadUserProfile(data.token));

  } catch (error) {
    throw error;
  }
};

export const loadUserProfile = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${apiUrl}/api/auth/me`, {
      headers: {
        Authorization: "Bearer " + token
      }
    });

    if (!res.ok) {
      throw new Error("Impossible de charger le profil");
    }

    const user = await res.json();

    dispatch({
      type: SET_USER,
      payload: user
    });
  } catch (error) {
    console.error(error);
  }
};

export const logout = () => async (dispatch, getState) => {
  const { token } = getState().auth;

  try {
    if (token) {
      await fetch(`${apiUrl}/api/auth/logout`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token
        }
      });
    }
  } catch (error) {
    console.error("Erreur lors de la déconnexion :", error);
  }

  // 1) Reset Redux immédiatement
  dispatch(resetAll());

  // 2) Purge redux-persist (storage session)
  persistor.purge();

  // 3) Action optionnelle (si ton reducer auth a LOGOUT)
  dispatch({ type: LOGOUT });
};

